import React from 'react';
import { Alert, CircularProgress } from '@mui/material';
import { Button } from 'components/Form';
import { performAssessmentHooks } from '.';

interface AssessmentAlertsProps {
  isInAssessmentMode: boolean;
  uploadingAssessmentIds: string[]; // או מערך של מספרים, בהתאם לטיפוס הנתונים אצלך
  stuckAssessmentIds: string[];
}

const AssessmentUploadNotifications: React.FC<AssessmentAlertsProps> = ({
  isInAssessmentMode,
  uploadingAssessmentIds,
  stuckAssessmentIds,
}) => {
  const performSync = performAssessmentHooks.usePerformSyncUploads();


  const isUploading = uploadingAssessmentIds && uploadingAssessmentIds.length > 0;
  const hasStuck = stuckAssessmentIds && stuckAssessmentIds.length > 0;


  // מצב 1: isInAssessmentMode דלוק ויש העלאות ברקע
  if (isInAssessmentMode && isUploading) {
    return (
      <Alert
        color="thirdly"
        severity="warning"
        action={
          <CircularProgress color="dark" size="28px" aria-label="Loading…" />
        }>
        המבדק הסתיים והתוצאות נשמרות במערכת. אין לסגור את המחשב או את החלון עד לסיום ההעלאה.

      </Alert>
    );
  }

  // מצב 2: הדגל מכובה ויש העלאות ברקע
  if (!isInAssessmentMode && isUploading) {
    return (
      <Alert
        color="error"
        severity="warning"
        action={
          <CircularProgress color="error" size="28px" aria-label="Loading…" />
        }>
        {" ישנם מבדקים בהעלאה. לא לכבות את האתר עד שתסתיים העלאה וכן לא להגיש תלמידים לביצוע מבדקים כדי שהעלאה תעבור חלק."}
      </Alert>
    );
  }

  // מצב 3: הדגל מכובה, אין העלאות פעילות, ויש מבדקים תקועים
  if (!isInAssessmentMode && !isUploading && hasStuck) {
    return (
      <Alert
        color="error"
        severity="warning"
        action={
          <Button variant="danger" color="error" size="small" action={performSync}>
            {"נסי להעלות שוב"}
          </Button>
        }
      >

        <div>{"חלק מהמבדקים בוצעו אך עדיין לא עלו למערכת, אולי בגלל בעיית אינטרנט. המערכת תנסה שוב אוטומטית."}</div>
        <div>
          {"אם אפשר, עברי למקום עם קליטה טובה יותר וללחוץ על"}
          <b>{'"נסי להעלות שוב"'}</b>
          {", או לנסות שוב לפני שעוזבים, כשהאינטרנט פחות עמוס."}
        </div>
        <div>
          <b>{"חשוב: השאירי את המחשב דולק ואת החלון פתוח עד שההתראה תיעלם. "}</b>
          {"תודה על הסבלנות!"}
        </div>
      </Alert>
    );
  }

  // אם לא מתקיים אף אחד מהמצבים, הקומפוננטה לא תציג כלום
  return null;
}

export default AssessmentUploadNotifications